import { ReactNode } from 'react';

import Footer from '@/components/layouts/Footer';
import Navbar from '@/components/layouts/Navbar';
import { CaseCardVariants } from '@/features/v2/MobileMenu';
import cn from '@/utils/cn';

const LayoutError = ({ children }: { children: ReactNode }) => {
  return (
    <div className="m-0 flex h-screen flex-col p-0">
      <Navbar caseCardVariant={CaseCardVariants.EMPTY} />
      <div className="flex w-full flex-col pb-[110px] lg:hidden"></div>
      <main
        className={cn(
          'mx-auto grow',
          'sm:max-w-screen-sm md:max-w-tablet lg:max-w-screen',
          'px-4 md:px-6 lg:px-8',
          'py-8 pb-[86px] lg:pb-[120px] lg:pt-[30px]'
        )}
      >
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default LayoutError;
